import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--password-validation"
export default class extends Controller {
  static targets = ["submitButton"];
  static values = {
    delay: { type: Number, default: 800 },
    disabledClass: String,
  };

  connect() {
    CsrfToken(this);
    TurboStreamHeaders(this);
    this.timeoutId = null;
  }

  disconnect() {
    this._clearExistingTimeout();
  }

  validate(e) {
    e.preventDefault();
    this._clearExistingTimeout();

    this.timeoutId = setTimeout(() => {
      this._requestPasswordValidation();
      this.timeoutId = null;
    }, this.delayValue);
  }

  _requestPasswordValidation() {
    const formData = new FormData(this.element);
    // RailsのRoutesのPUTは、formのmethodがPOSTで、hiddenに_method: putが含まれるため、
    // formDataから_methodを除外しないとputでリクエストが送られるため、_methodを削除する
    formData.delete("_method");

    fetch("/user_password_validations", {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        const ok = response.ok;
        const status = response.status;
        if (!ok && status !== 422) {
          throw new Error("Network response was not ok");
        }

        return response.text().then((html) => ({ status, ok, html }));
      })
      .then(({ status, ok, html }) => {
        Turbo.renderStreamMessage(html);
        if (ok) {
          this.submitButtonTarget.classList.remove(this.disabledClassValue);
        } else {
          this.submitButtonTarget.classList.add(this.disabledClassValue);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }

  _clearExistingTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
